'use client';

import error505 from '@dev-landing/public/505.svg';
import {Footer, SwitchLanguage} from '@ui-kit/src';
import {useReportErrorFromBoundary} from '@utils/tracer/useReportErrorFromBoundary';

import {parseFooterData} from '@dev-landing/components/StrapiFooter/Support/parseFooterData';
import HeaderComponent from '@dev-landing/components/StrapiHeader/Header';

import {footerFallbackRu} from '@dev-landing/strapi/lib/footerFallback';
import {headerFallbackRU} from '@dev-landing/strapi/lib/headerFallback';

import styles from './Error505.module.scss';

export const Error505 = ({error}: {error: Error & {digest?: string}}) => {
  useReportErrorFromBoundary(error, error.digest);

  const footerProps = parseFooterData(footerFallbackRu as any);

  return (
    <>
      <HeaderComponent
        locale="ru"
        links={headerFallbackRU.links}
        logo={{
          logoHref: headerFallbackRU.logo.logoHref.url,
          afterLogoImageHref: headerFallbackRU.logo.afterLogoImageHref.url,
          href: '/',
        }}
        mobileMenu={{mobileMenuTitle: 'Меню'}}
        consoleLinkHref="https://console.rustore.ru/sign-up/"
        consoleLinkText="Создать аккаунт"
        activeLinkOrder={3}
      />
      <div className={styles.wrapper}>
        <img src={error505.src} alt="505" />
        <h2 className={styles.title}>Что-то пошло не так</h2>
        <span className={styles.subtitle}>
          Попробуйте обновить страницу или зайти позже
        </span>
        <button
          className={styles.button}
          onClick={() => window.location.reload()}
        >
          Обновить страницу
        </button>
      </div>
      <Footer
        {...footerProps}
        leftSideContent={{
          ...footerProps.leftSideContent,
          underLogoContent: <SwitchLanguage />,
        }}
      />
    </>
  );
};
